import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export default function (ComposedComponent) {
  class RequireStandardPlanForSubscribe extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    redirect(to) {
      global.window && window.location && window.location.replace(to);
    }

    render() {
      if (this.props.isLoading) {
        return <div></div>;
      }

      const { user } = this.props;
      if (user && user.isCustomPlan && user.status === 'trial') {
        this.redirect('/');
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      isLoading: state.auth.isLoading,
      user: state.auth.user,
    };
  }

  return connect(mapStateToProps)(RequireStandardPlanForSubscribe);
}
